<template>
  <div class="custom-switch">
    <v-switch
      :input-value="inputValue"
      v-bind="$attrs"
      :ripple="false"
      inset
      hide-details
      @change="$emit('change', $event)"
    ></v-switch>
  </div>
</template>

<script>
export default {
  name: "UiSwitch",
  model: {
    prop: "inputValue",
    event: "change"
  },
  props: {
    inputValue: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-switch {
  height: 30px;

  ::v-deep {
    .v-input--selection-controls {
      margin-top: 0;
      position: relative;
      top: -2px;
      margin-right: 0;
    }

    .v-input--switch--inset .v-input--selection-controls__input {
      width: 51px;
      margin-right: 0;
    }

    .v-input--switch__thumb {
      color: $light !important;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.01),
        0 3px 1px rgba(0, 0, 0, 0.03);
      width: 26px;
      height: 26px;
      top: 0;
      left: 2px;
    }

    .v-input--switch--inset .v-input--switch__track {
      opacity: 1;
      width: 50px;
      height: 30px;
      border-radius: 16px;
      left: 0;
      transition: background 0.2s ease-in-out;
    }

    .v-input--switch--inset:not(.v-input--is-label-active)
      .v-input--switch__track {
      background: $light-3;
    }

    .v-input__slot {
      .v-input--selection-controls__input {
        order: 1;
      }

      .v-label {
        order: 0;
        color: rgba($dark-blue-3, 0.9);
        @include font-size(14px);
        line-height: 17px;
        margin-right: $spacing * 2;
        font-weight: 500;
        flex: 0 1 auto;
      }
    }
  }
}
</style>
